import { useState, useEffect } from 'react';
import useAuth from './useAuth';
import { listCalendarEvents } from '../firebase/admin';

// Loads upcoming calendar events for the signed-in member. Returns
//   { events, status }  where status is loading | signedOut | error | ready.
// Shared by the home Events section and the full /events page (they just differ
// in `max` and how much of the result they display).
export default function useCalendarEvents({ max } = {}) {
  const user = useAuth(); // undefined = resolving, null = signed out, User = signed in
  const [events, setEvents] = useState([]);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (user === undefined) return undefined; // auth still resolving
    if (!user) {
      setEvents([]);
      setStatus('signedOut');
      return undefined;
    }
    let cancelled = false;
    setStatus('loading');
    listCalendarEvents({ max })
      .then((evs) => {
        if (cancelled) return;
        setEvents(evs);
        setStatus('ready');
      })
      .catch(() => {
        if (!cancelled) setStatus('error');
      });
    return () => {
      cancelled = true;
    };
  }, [user, max]);

  return { events, status };
}
